import { createFileRoute, notFound } from '@tanstack/react-router';
import { TransactionPage } from '../components/pages/TransactionPage/TransactionPage';
import { z } from 'zod/mini';

const transactionSearchSchema = z.object({
  createdAt: z.catch(z.string(), ''),
});

export const Route = createFileRoute('/account/transactions_/$transactionId')({
  component: TransactionPage,
  validateSearch: (search) => {
    const result = transactionSearchSchema.safeParse(search);
    if (!result.success) {
      throw notFound();
    }
    return result.data;
  },
  onError: (error) => {
    console.error(error);
    throw notFound();
  },
});
